// extracted by mini-css-extract-plugin
export default {"tab":"Tab_tab__9oOFt","highlighted":"Tab_highlighted__UwDgJ"};